import React, { CSSProperties } from 'react';
import { Loader as CosmaLoader } from 'is24-corecss';

export type LoaderProps = {
  styles?: CSSProperties;
  size?: 'large' | 'small' | 'medium' | undefined;
};

export const Loader = ({ styles = {}, size = 'large' }: LoaderProps) => (
  <div role='loader' className='align-center vertical-center-container' style={styles}>
    <div className='vertical-center'>
      <CosmaLoader size={size} />
    </div>
  </div>
);
